import React from 'react';
import { FlexColumn } from 'styles/Layout';
import styled from 'styled-components';
import { media } from 'styles/Mixins';
import Benefit from 'modules/external_tenant/components/index/benefits_section/BenefitItemComponent';
import { IndexTitle } from 'modules/external_tenant/shared/styles';
import { ExternalTenantAssets } from 'utils/ExportCommon';

const BENEFITS = [
  {
    imageSrc: ExternalTenantAssets.ApplyBenefit,
    text: 'Aplica en línea y sin papeleos',
    textWidth: '126px',
    imageWidth: '143px',
    imageHeight: '104px'
  },
  {
    imageSrc: ExternalTenantAssets.NoPaperworkBenefit,
    text: 'Sin trámites engorrosos ni avales',
    textWidth: '126px',
    imageWidth: '95px',
    imageHeight: '102px'
  },
  {
    imageSrc: ExternalTenantAssets.WarrantyBenefit,
    text: 'Depósito de garantía a meses sin intereses',
    textWidth: '134px',
    imageWidth: '110px',
    imageHeight: '110px'
  },
  {
    imageSrc: ExternalTenantAssets.PaymentsBenefit,
    text:
      'Paga tu renta como mejor te acomode (tdc, spei, efectivo) y acumula puntos Club Premier',
    textWidth: '199px',
    imageWidth: '117px',
    imageHeight: '86px'
  },
  {
    imageSrc: ExternalTenantAssets.IntermediaryBenefit,
    text:
      'Olvídate de las fricciones con tu propietario y deja que Homie te acompañe en el proceso',
    textWidth: '193px',
    imageWidth: '99px',
    imageHeight: '112px'
  }
];

const Container = styled(FlexColumn)`
  background-color: #fff;
`;

const Title = styled(IndexTitle)`
  display: none;
  margin: 10px 0 40px 0;
  ${media.sm`
    display: block;
  `};
`;

const BenefitsContainer = styled(FlexColumn)`
  margin: 0;
  padding: 0;
  ${media.sm`
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 0 34px;
    margin: 3px 0 40px 0;
  `};
`;

export default function BenefitsSection() {
  return (
    <Container>
      <Title>Beneficios de ser un inquilino</Title>
      <BenefitsContainer>
        {BENEFITS.map((benefit, index) => (
          <Benefit {...benefit} key={index} index={index} />
        ))}
      </BenefitsContainer>
    </Container>
  );
}
